import * as types from '../constants/ActionTypes'

const initialState = {
  Status: null,
  apiGetResult: null,
  filedetails:null,
  userPhoto:null,
}

export default function fileupload(state = initialState, action) {
  switch (action.type) {
    case types.UPLOAD_FILE_REQUEST:
      return {
        ...initialState,
        Status:true
      };
    case types.UPLOAD_FILE_REQUEST_COMPLETED:
      return {
        ...state,
        Status:false,
        apiGetResult: true,
        filedetails:action.data
      };
    case types.UPLOAD_FILE_REQUEST_ERROR:
      return {
        ...state,
        Status:false,
        apiGetResult: false,
      };
      case types.DOWNLOAD_PHOTO_REQUEST:
        return {
          ...initialState,
          Status:true
        };
      case types.DOWNLOAD_PHOTO_REQUEST_COMPLETED:
        return {
          ...state,
          Status:false,
          apiGetResult: true,
          userPhoto:action.data
        };
      case types.DOWNLOAD_PHOTO_REQUEST_ERROR:
        return {
          ...state,
          Status:false,
          apiGetResult: false,
        };
    default:
      return state;
  }
} 


// WEBPACK FOOTER //
// ./reducers/fileupload.js